// Leaf enum module. Extracted from index.ts so zod schemas (types/schemas.ts)
// can reference UnitSystem at runtime without a circular import back through
// index.ts (which itself derives its document types from the schemas).

// Unit system — const object so the type is a string union compatible with
// the bim-pdf packages' UnitSystem strings, while call sites keep the UnitSystem.METRIC /
// UnitSystem.IMPERIAL spelling unchanged.
export const UnitSystem = {
    METRIC: 'metric',
    IMPERIAL: 'imperial',
} as const;
export type UnitSystem = (typeof UnitSystem)[keyof typeof UnitSystem];

// Text size preset for text markups.
export const TextSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
} as const;
export type TextSize = (typeof TextSize)[keyof typeof TextSize];
